import React, { Component } from 'react';
import styles from './permissions.module.scss';
import classnames from 'classnames';
import { strings } from '../../components/utils/translations';
import { Utils } from '../../components/utils/utils';
import API from '../../components/utils/API';
import moment from "moment";
import Colors from '../../css/vars.scss'

import CloseIcon from '../../img/icons/closeIcon';
import PrimaryButton from '../../components/Buttons/primaryButton';
import GaragesIcon from '../../img/icons/GaragesIcon';
import ClockIcon from '../../img/icons/ClockIcon';
import InfiniteIcon from '../../img/icons/infinite-icon.svg';
import RecurrentIcon from '../../img/icons/RecurrentIcon';
import StatusIcon from '../../img/icons/EventIcon';
import DefaultGarageBackground from '../../img/default_garage.png'

import { CalendarOutlined } from '@ant-design/icons';
import Loader from '../../components/Loader/index';
import { Tooltip, Popover, Progress } from 'antd'

export default class ConfirmationPermissions extends Component
{
	constructor(props)
	{
		super(props);

		this.state =
		{
            selectedDoors: props.selectedDoors,
            users: props.users,
            usersByInvitation: props.usersByInvitation,
            permission: props.permission,
            permissionIds: props.permissionIds,
            closePermissions: props.closePermissions,
			myPermissionsInDoors: [],

            permission: {
                roleType: null,
                permissionsToGrant: 0,
            },
            permissionRoleType: null,
            permissionsToGrant: 0,
            permissionFrequency: null,
            permissionStartDate: null,
            permissionEndDate: null,
            permissionRecurrentDays: [],

			isSending: false,
            invitationsSent: false,
            permissionStatusResponses: [],
			
            doorSelected: null,
            showResultDetail: null,
            guestEmail: null,
			
			numGrantPermissionsSent: 0,
			showProgress: true
		}
		
		this.numTotalPermissions = 0
		this.checkedRegisteredUsers = []
		this.permissionIdsToRevoke = []
	}

    static getDerivedStateFromProps(props, state)
	{
		let newState = null
		
		if (props.permission != state.permission && props.permission != null)
		{
			if (newState === null)
				newState = {}
			
			newState.permission = props.permission
			newState.permissionRoleType = props.permission.roleType
			newState.permissionsToGrant = props.permission.permissionsToGrant
			newState.permissionFrequency = props.permission.frequency
			newState.permissionStartDate = props.permission.startDate
			newState.permissionEndDate = props.permission.endDate
			newState.permissionRecurrentDays = props.permission.permissionDays
		}
		
		return newState
	}
	
	render()
	{
		return (
            <div className={styles.selectDoorsContainer}>
                <div className="responsive-container">
                    <div className={styles.permissionsTopBar}>
                        <div>
                            <h3 className={styles.title}>{this.state.invitationsSent ? strings('giveVRConfTitleSent') : strings('giveVRConfTitle')}</h3>
                            <p className={styles.subtitle}>{this.state.invitationsSent ? strings('giveVRConfSubtitleSent') : strings('giveVRConfSubtitle')}</p>
                        </div>
                        <CloseIcon className={styles.closeIcon} size="22" onClick={this.state.closePermissions} />
                    </div>
					
					<div className={styles.permissionCenterContent}>
	                    <div className={styles.permissionDoubleContent}>
							<div className={styles.confirmationLeftContainer}>
		                        <div className={ classnames([styles.firstBlock, styles.confirmation]) }>
		                            <div className={styles.doors}>
										<h3 className={styles.subtitle}>{strings('doors')} <span className={styles.total}>({this.props.selectedDoors.length})</span></h3>
			                            <div className={styles.confirmationContent}>
											<div className={styles.usersContainer}>
			                                {
												this.props.selectedDoors.map((door) =>
												{
													const cardImg = (door.imageURL !== null) ? door.imageURL : DefaultGarageBackground
													
													return (
					                                    <div
															className={classnames([
																			styles.card,
																			styles.doors,
																			{
																				[styles.selectable]: this.state.invitationsSent || this.state.isSending,
																				[styles.selected]: (this.state.invitationsSent || this.state.isSending) && door.id === this.state.doorSelected.id
																			}
																		])}
					                                        onClick={() => { if (this.state.invitationsSent || this.state.isSending) this.setState({ doorSelected: door}) }}
					                                    >
					                                        <div className={styles.iconContent}>
																<div className={styles.imageContainer}>
																	<img src={cardImg} className={styles.image} onError={(ev) => ev.target.src = DefaultGarageBackground} />
																</div>
					                                            <p className={styles.text}>{door.name}</p>
					                                        </div>
					                                        {
																(this.state.invitationsSent || this.state.isSending) &&
					                                            <div className={styles.resultsContainer}>
					                                                <div className={classnames([styles.circle, styles.success])}>
					                                                    { this.countSuccessfulDoors(door.id) }
					                                                </div>
					                                                <div className={classnames([styles.circle, styles.error])}>
					                                                    { this.countErrorDoors(door.id) }
					                                                </div>
					                                            </div>
					                                        }
					                                    </div>
			                                		)
												})
											}
											</div>
			                            </div>
									</div>
								</div>
								
								<div className={ classnames([styles.firstBlock, styles.confirmation, styles.permissionBlock]) }>
		                            <div className={styles.permissionContainer}>
										<div className={styles.topContainer}>
			                                <h3 className={styles.subtitle}>{ strings('permission') }</h3>
										</div>
											
			                            <div className={classnames([styles.confirmationContent, styles.permissionDetailsAndVR])}>
											<div>
												<div className={styles.label}>
													{this.state.permissionRoleType === 'owner' ? strings('owner') : strings('guest')}
												</div>
				                                <div className={classnames([styles.card, styles.permission])}>
				                                    <div className={styles.iconContent}>
				                                        {(this.state.permissionFrequency === 'unlimited' ||
				                                            this.state.permissionRoleType === 'owner') &&
				                                           <img className={styles.icon} src={InfiniteIcon} />
				                                        }
				                                        {this.state.permissionFrequency === 'temporary' &&
				                                            <ClockIcon
				                                                size='26px'
				                                                color='#9333FF'
				                                                className={styles.icon}
				                                            />
				                                        }
				                                        {this.state.permissionFrequency === 'recurrent' &&
				                                            <RecurrentIcon
				                                                size='26px'
				                                                color='#9333FF'
				                                                className={styles.icon}
				                                            />
				                                        }
				                                        <p className={styles.text}>{ strings('permission') }
				                                            {(this.state.permissionFrequency === 'unlimited' ||
				                                              this.state.permissionRoleType === 'owner') && ` ${strings('unlimited')}`}
				                                            {this.state.permissionFrequency === 'temporary' && ` ${strings('temporary')}`}
				                                            {this.state.permissionFrequency === 'recurrent' && ` ${strings('recurrent')}`}
				                                        </p>
				                                    </div>
				                                    {((this.state.permissionRoleType === 'guest') &&
				                                        (this.state.permissionFrequency === 'recurrent' ||
				                                        this.state.permissionFrequency === 'temporary')) &&
														<Popover
															content={this.renderPermissionDetailTooltipContent()}
															placement="right"
															mouseEnterDelay={0.03}
															mouseLeaveDelay={0.03}
														>
															<div className={styles.calendarIcon}>
						                                        <CalendarOutlined
						                                            style={{ fontSize: '15px', color: '#ADAEB2' }}
						                                        />
															</div>
														</Popover>
				                                    }
				                                    {((this.state.permissionRoleType === 'owner') &&
				                                        (this.state.permissionsToGrant > 0 )) &&
				                                        <div className={styles.remoteIconPermissions}>
				                                            <span className={styles.permissionNumber}>{this.state.permissionsToGrant}</span>
				                                            <img width="14" height="18" src={require('../../img/icons/remote_gray.svg').default} />
				                                        </div>
				                                    }
				                                </div>
											</div>
											<div>
												<div className={styles.label}>
													{ strings('virtualRemote') }
												</div>
												<div className={classnames(styles.card, styles.subscriptionCard)}>
													{ this.renderSubscriptionView() }
												</div>
											</div>
			                            </div>
									</div>
		                        </div>
							</div>
							
							<div className={styles.middleBlock}></div>
							
	                        <div className={ classnames([styles.secondBlock, styles.confirmation]) }>
	                            <h3 className={styles.subtitle}>
								{
									(this.state.invitationsSent || this.state.isSending) ?
									<>
										{strings('giveVRConfResults')}<br/>
										<span className={classnames(styles.total, styles.doorName)}>{ this.state.doorSelected.name }</span>
									</>
									:
									<>{strings('users')} <span className={styles.total}>({this.props.users.length + this.props.usersByInvitation.length})</span></>
								}
								</h3>
	                            {
									((this.props.users.length > 0) || (this.props.usersByInvitation.length > 0)) && (this.state.invitationsSent === false && !this.state.isSending) &&
	                                <div className={styles.confirmationContent}>
										<div className={styles.usersContainer}>
		                                    {
												this.props.users.map((user) => (
		                                        <div className={ classnames([styles.card, styles.users]) }>
	                                                <div className={styles.iconContent}>
	                                                    <div className={styles.circle}>
	                                                        { Utils.getInitials( user.name + ' ' + user.lastName ) }
	                                                    </div>
	                                                    <div className={styles.userInfo}>
	                                                        <p className={styles.name}>
	                                                            { user.name + ' ' + user.lastName }
	                                                        </p>
	                                                        <p className={styles.email}>
	                                                            {user.email}
	                                                        </p>
	                                                    </div>
	                                                </div>
		                                        </div>
		                                    ))}
		                                    {
												this.props.usersByInvitation.map((user) => (
	                                            <div className={ classnames([styles.card, styles.users]) }>
	                                                <div className={styles.iconContent}>
	                                                    <div className={styles.circle}>
	                                                        { Utils.getInitials(user.name) }
	                                                    </div>
	                                                    <div className={styles.userInfo}>
	                                                        <p className={styles.name}>
	                                                            { user.name }
	                                                        </p>
	                                                        <p className={styles.email}>
															{
																user.email?.length > 0 ?
																(
																	user.phoneNumber?.length > 0 ?
																	`${user.email}/${user.phoneNumber}`
																	:
																	user.email
																)
																:
																user.phoneNumber
															}
	                                                        </p>
	                                                    </div>
	                                                </div>
	                                            </div>
		                                        ))
		                                    }
										</div>
	                                </div>
	                            }
								
								{
									(this.state.invitationsSent || this.state.isSending) &&
		                            <div className={styles.confirmationContent}>
										<div className={styles.usersContainer}>
			                                {
												this.state.permissionStatusResponses.map((user) => (
			                                    <>
			                                    {
													(this.state.doorSelected.id == user.doorId) &&
													<Tooltip
														title={() => (
															<div className={styles.resultDetailMessage}>
																{
																	(user.invitationEmailSentOk === false) ?
																	<p>{ strings('giveVRConfSendError') }</p>
																	:
																	(
																		<>
						                                                    {user.status === 200 && <p>{ strings('giveVRConfSendSuccess') }</p>}
																			{
																				(user.status === 404) ?
																				(
																					(user.appError === 711) ?
																					<><p>{ strings('giveVRConfSendErrorNotEnough') }</p><code>{ strings('giveVRConfSendErrorNotEnough2') }</code></>
																					:
																					<p>{ user.errorMessage ? user.errorMessage : strings('giveVRConfSendErrorStartingDate') }</p>
																				)
																				: null
																			}
						                                                    {user.status === 401 && <p>{ strings('giveVRConfSendError401') }</p>}
						                                                    {user.status === 409 && <><p>{ strings('giveVRConfSendError409') }</p><code>{ strings('giveVRConfSendError409_2') }</code></>}
																			{user.status === -1 && <p>{ user.errorMessage }</p>}
																		</>
																	)
																}
			                                                </div>
														)}
														color={(user.status !== 200 || (user.invitationEmailSentOk === false)) ? 'rgb(255,59,48)' : 'rgb(52,199,89)' }
														key={user.guestEmail}
														placement="right"
														mouseEnterDelay={0.03}
														mouseLeaveDelay={0}
													>
			                                            <div className={ classnames([styles.card, styles.users]) }
			                                                onMouseEnter={() => this.setState({ showResultDetail: true, guestEmail: user.guestEmail })}
			                                                onMouseLeave={() => this.setState({ showResultDetail: false })}
			                                            >
			                                                <>
			                                                    <div className={styles.iconContent}>
			                                                        <div className={styles.circle}>
			                                                            { Utils.getInitials( user.guestName ) }
			                                                        </div>
			                                                        <div className={styles.userInfo}>
			                                                            <p className={styles.name}>
			                                                                { user.guestName }
			                                                            </p>
			                                                            <p className={styles.email}>
			                                                                {
																				user.guestEmail?.length > 0 ?
																				(
																					user.guestPhone?.length > 0 ?
																					`${user.guestEmail}/${user.guestPhone}`
																					:
																					user.guestEmail
																				)
																				:
																				user.guestPhone
																			}
			                                                            </p>
			                                                        </div>
			                                                    </div>
		                                                        <div
																	className={classnames(styles.status,
																						  (user.status !== 200 || (user.invitationEmailSentOk === false)) ? styles.error : styles.success)}
																>
			                                                    </div>
			                                                </>
			                                            </div>
													</Tooltip>
			                                    }
			                                    </>
											))}
										</div>
		                            </div>
								}
								
								{
									(this.state.showProgress && (this.state.invitationsSent || this.state.isSending)) &&
									<div className={styles.progressbarContainer}>
										{
											!this.state.invitationsSent &&
											<div className={styles.sendingText}>
												{ strings('sendingVirtualRemotes') }
											</div>
										}
										
										<Progress
											percent={parseInt((this.state.numGrantPermissionsSent/this.numTotalPermissions)*100)}
											strokeColor={this.state.invitationsSent ? null : Colors.purplePrimary}
											trailColor={Colors.systemGray5}
											format={percent => `${this.state.numGrantPermissionsSent}/${this.numTotalPermissions}`}
										/>
									</div>
								}
	                        </div>
	                    </div>
					</div>

                    <div className={styles.footerBtnPosition}>
						{
							(!this.state.invitationsSent && !this.state.isSending) ?
							<PrimaryButton
								text={strings('back')}
								onClick={() => this.props.goBack()}
								white
							/>
							: <div></div>
						}
					
                        <div className={styles.continueBtn}>
							{/*
                            <a
                                className={styles.link}
                                onClick={ () => this.onEditPermissions() }
                            >
								{ this.state.invitationsSent && 'Crear nuevos mandos virtuales' }
							</a>*/}
							{
								this.state.isSending ?
								<Loader spinner gray />
								:
	                            <PrimaryButton
	                                text={this.state.invitationsSent ? strings('close') : strings('giveVRConfSendInvitations')}
	                                onClick={this.state.invitationsSent ? this.state.closePermissions : () => this.sendInvitationsToUsers() }
	                            />
							}
                        </div>
                    </div>
                </div>
			</div>
		);
	}
	renderPermissionDetailTooltipContent()
	{
		return (
			<div className={styles.permissionDetailBoxContainer}>
				{
					this.state.permission.frequency === 'temporary' &&
					<>
						<h4 className={styles.title}>Desde</h4>
							<p>{moment(this.state.permission.startDate).format('DD/MM/YYYY HH:mm')}</p>
						<h4 className={styles.title}>Hasta</h4>
							<p>{moment(this.state.permission.endDate).format('DD/MM/YYYY HH:mm')}</p>
					</>
				}
				{
					this.state.permission.frequency === 'recurrent' &&
					<>
						<h4 className={styles.title}>Desde</h4>
							<p>{moment(this.state.permission.startDate).format('DD/MM/YYYY')}</p>
						<h4 className={styles.title}>Hasta</h4>
							<p>{moment(this.state.permission.endDate).format('DD/MM/YYYY')}</p>
						<h4 className={styles.title}>Días de la semana</h4>
						<div className={styles.daysContainer}>
							{
								this.state.permission.permissionDays.map((day) => (
								<div className={styles.whiteCircle}>
									{day.dayOfWeek == 1 && 'L'}
									{day.dayOfWeek == 2 && 'M'}
									{day.dayOfWeek == 3 && 'X'}
									{day.dayOfWeek == 4 && 'J'}
									{day.dayOfWeek == 5 && 'V'}
									{day.dayOfWeek == 6 && 'S'}
									{day.dayOfWeek == 0 && 'D'}
								</div>
							))}
						</div>
					</>
				}
			</div>
		)
	}
	renderSubscriptionView()
	{
		let item = this.props.selectedSubscription
		let subscriptionType = item.type
        let subscriptionStatus = item.status
        let subscriptionIcon = require('../../img/icons/remote_big_gray.svg').default
        let subscriptionTitle = strings('vrPermissionTitleFree')
        let subscriptionSubtitle = strings('vrPermissionDoesntExpire')
        let subscriptionSubtitle2 = null
        let isExpired = item.virtualRemotes[0]?.virtualRemote?.expired
        
        if (subscriptionType === '1 year')
        {
            subscriptionIcon  	 = require('../../img/icons/remote_big_purple.svg').default
            subscriptionTitle 	 = strings('vrPermissionTitle1Year')
            subscriptionSubtitle = null
            subscriptionSubtitle2 = isExpired ?
                                    `${strings('expiredOn')} ${moment(item.virtualRemotes[0]?.expireDate).format('LL')}`
                                    : `${strings('expires')}: ${moment(item.virtualRemotes[0]?.expireDate).format('LL')}`
        }
        else if (subscriptionType === '5 years')
        {
            subscriptionIcon  	 = require('../../img/icons/remote_big_gold.svg').default
            subscriptionTitle 	 = strings('vrPermissionTitle5Year')
            subscriptionSubtitle = null
            subscriptionSubtitle2 = isExpired ?
                                    `${strings('expiredOn')} ${moment(item.virtualRemotes[0]?.expireDate).format('LL')}`
                                    : `${strings('expires')}: ${moment(item.virtualRemotes[0]?.expireDate).format('LL')}`
        }
		
		return (
			<div className={styles.subscription}>
				<img className={styles.subscriptionIcon} src={subscriptionIcon} />
				<div className={styles.subscriptionTexts}>
					<div className={styles.subscriptionTitle}>{ subscriptionTitle }</div>
					<div className={styles.subscriptionSubtitle}>
						{ subscriptionSubtitle }
						{
							(subscriptionStatus === 'trial') &&
							<div className={styles.orange}> ({strings('trialMode').toLowerCase()})</div>
						}
					</div>
					{
						subscriptionSubtitle2 &&
						<div className={classnames(styles.subscriptionSubtitle, isExpired ? styles.orange : null)}>
							{ subscriptionSubtitle2 }
						</div>
					}
				</div>
			</div>
		)
	}

    countSuccessfulDoors(doorId)
    {
        var count = 0;
        for(var i = 0; i < this.state.permissionStatusResponses.length; ++i){
            if((this.state.permissionStatusResponses[i].status == 200) && (this.state.permissionStatusResponses[i].doorId == doorId))
                count++;
        }
        return count;
    }
    countErrorDoors(doorId)
    {
        var count = 0;
        for(var i = 0; i < this.state.permissionStatusResponses.length; ++i){
            if((this.state.permissionStatusResponses[i].status !== 200) && (this.state.permissionStatusResponses[i].doorId == doorId))
                count++;
        }
        return count;
    }

    async sendInvitationsToUsers()
    {
		this.setState(
		{
			isSending: true,
			invitationsSent: false,
			permissionStatusResponses: [],
			numGrantPermissionsSent: 0
		})
		this.permissionIdsToRevoke = []

        var firstDoor = this.props.selectedDoors.find((door) => door)
        this.setState({ doorSelected: firstDoor })

        let permission = {
            roleType: this.state.permissionRoleType,
            permissionsToGrant: this.state.permissionsToGrant,
            ...(this.state.permissionFrequency === 'temporary' && 
                {startDate: this.state.permissionStartDate,
                endDate: this.state.permissionEndDate}
            ),
            ...(this.state.permissionFrequency === 'recurrent' && 
                {startDate: this.state.permissionStartDate,
                endDate: this.state.permissionEndDate,
                permissionDays: this.state.permissionRecurrentDays}
            ),
        }

        var newPermissions = []

        // For users in agenda
        for (var i = 0; i < this.props.users.length; i++)
		{
            newPermissions.push(
                {...permission,
                    guestEmail:this.props.users[i].email,
                    guestName: this.props.users[i].name
            })
        }

        // For imported users
        for (var i = 0; i < this.props.usersByInvitation.length; i++)
		{
            newPermissions.push(
                {...permission,
                    guestEmail: this.props.usersByInvitation[i].email,
                    guestName: this.props.usersByInvitation[i].name,
					guestPhone: this.props.usersByInvitation[i].phoneNumber
            })
        }
		
		let emailsToCheck = newPermissions.map(p => p.guestEmail)
		this.checkedRegisteredUsers = await this._checkRegisteredUsers(emailsToCheck)

        // Set doors for permission
		let finalPermissions = []
		for (var i = 0; i < this.props.selectedDoors.length; i++)
		{
            newPermissions.forEach(permission =>
            {
				let hasHomyhubAccount = this.checkedRegisteredUsers.find(checkRes => checkRes.email === permission.guestEmail) != null
				finalPermissions.push({...permission, doorId:this.props.selectedDoors[i].id, hasHomyhubAccount})
            })
		}

		this.numTotalPermissions = finalPermissions.filter(p => p.doorId).length
		console.log(finalPermissions)
		let finalPermissionsInBatches = this._sliceArrayIntoBatches(finalPermissions, 1)

		for (let permissionsBatch of finalPermissionsInBatches)
        {
			await this._grantPermissionBatch(permissionsBatch, this.numTotalPermissions)
        }
    }
	
	_sliceArrayIntoBatches(arr, batchSize)
	{
	    const batches = []
	    let i = 0
	    const n = arr.length

	    while (i < n) {
	      batches.push(arr.slice(i, i += batchSize))
	    }

	    return batches
	}

	_grantPermissionBatch(batch, numTotalPermissions)
	{
		let solvedPromises = 0
				
		return new Promise((resolve) =>
		{
			batch.forEach(async (permission) =>
			{
				try
				{
                	let result = await this._grantPermission(permission)
					
					let permissionStatusResponses = this.state.permissionStatusResponses.concat(result)
					//permissionStatusResponses.sort((userA, userB) => userA.guestName.localeCompare(userB.guestName))
                    this.setState({ permissionStatusResponses }, () =>
					{
						//console.log(this.state.permissionStatusResponses)
						this.setState({ numGrantPermissionsSent: this.state.numGrantPermissionsSent+1 }, () =>
						{
							if (this.state.numGrantPermissionsSent === numTotalPermissions)
							{
								this.setState({ isSending: false, invitationsSent: true }, () =>
								{
									setTimeout(() => this.setState({ showProgress: false }), 5000)
									this._revokePermissions()
								})
							}
						})
					})
					
					solvedPromises++
					if (solvedPromises === batch.length)
						resolve()
                }
                catch(error)
                {
                    console.log(error)
					
					this.setState({ numGrantPermissionsSent: this.state.numGrantPermissionsSent+1 }, () =>
					{
						if (this.state.numGrantPermissionsSent === numTotalPermissions)
						{
							this.setState({ isSending: false, invitationsSent: true }, () =>
							{
								setTimeout(() => this.setState({ showProgress: false }), 5000)
								this._revokePermissions()
							})
						}
					})
						
					solvedPromises++
					if (solvedPromises === batch.length)
						resolve()
                }
			})
		})
	}
	_grantPermission(data)
	{
		console.log('_grantPermission', new Date())
        return new Promise((resolve, reject) =>
        {
			(async () =>
			{
				try
				{
					let response = await API.getInstance().grantPermission(data)
	            	
					let permissionIds = [...this.state.permissionIds]
					permissionIds.push(response.data.permission.id)
					this.setState({ permissionIds })
					
	                let userHasHomyhubAccount = data.hasHomyhubAccount
					if (userHasHomyhubAccount)
					{
						let assignRes = await this._assignVirtualRemote(response.data.permission.userId, response.data.permission.doorId, response.data.permission)
					}
					else
					{
						let myPermission = await this._getMyPermissionInDoor(response.data.permission.doorId)
						let virtualRemotes = this._getAvailableVirtualRemotes(myPermission, 1+this.state.permissionsToGrant)
						
						if (virtualRemotes == null)
						{
							reject("No hay suficientes Mandos Virtuales en la suscripción seleccionada.")
							return
						}
						
						let reserveRes = await this._reserveVirtualRemotes(response.data.permission.id, virtualRemotes)
						let sendEmailRes = await this._sendRemote(response.data.permission.id, data.guestEmail, data.guestPhone)
					}

	                let responsePermission = []
	                responsePermission.push({...data, status: response.status, id: response.data.permission.id})

	                resolve(responsePermission)
				}
	            catch(error)
	            {
					console.log(error)
	                let responsePermissionError = []
	                let errorStatus  = error?.response ? error.response.status : -1
					let errorMessage = error?.response?.data?.error?.message
					let appError = error?.response?.data?.error?.appError
					
					if (errorStatus === -1 && errorMessage == null)
						errorMessage = strings('sendVirtualRemoteError')
					
	                responsePermissionError.push({...data, status: errorStatus, errorMessage, appError})
	                resolve(responsePermissionError)
	            }
			})()
        })
    }
	
	async _revokePermissions()
	{
		for (let i = 0; i < this.permissionIdsToRevoke.length; i++)
		{
			try
			{
				let res = await this._revokePermission(this.permissionIdsToRevoke[i])
				console.log(res)
			}
			catch(error)
			{
				console.log(error)
			}
		}
	}
	async _revokePermission(permissionId)
	{
		console.log(`_revokePermission(${permissionId})`, new Date())
		return API.getInstance().revokePermission(permissionId)
    }

    _checkRegisteredUsers(emailsArray)
    {
		console.log('_checkRegisteredUsers', new Date())
		return new Promise(async (resolve, reject) =>
		{
			try
			{
				let res = await API.getInstance().checkRegisteredUsers(emailsArray)
				resolve(res.data.matchedContacts)
			}
			catch(error)
			{
				console.log(error)
				reject(error)
			}
		})
    }
	_getAvailableVirtualRemotes(myPermission, numRemotesToReserve)
	{
		console.log('Selected sub: ', this.props.selectedSubscription.id)
		let availableRemotes = myPermission.virtualRemotes.owned.filter(vr =>
			{
				return (!vr.reservedByApp && !vr.virtualRemote?.assigned && !vr.virtualRemote?.reserved &&
				((this.props.selectedSubscription.id === 'permanent') ?
					vr.virtualRemote?.type === 'permanent'
					:
					vr.subscription?.id === this.props.selectedSubscription.id
				))
			})
		console.log('Available remotes before slice', availableRemotes)
		
		// Order by id
		availableRemotes.sort((vrA, vrB) =>
		{
			if (vrA.virtualRemoteId < vrB.virtualRemoteId)
				return -1
			else if (vrA.virtualRemoteId > vrB.virtualRemoteId)
				return 1
			else return 0
		})
		
		let finalAvailableRemotes = availableRemotes.slice(0, numRemotesToReserve)
		finalAvailableRemotes.forEach(vr => vr.reservedByApp = true)
		
		console.log('Available remotes after slice', finalAvailableRemotes)
		
		return (finalAvailableRemotes.length >= numRemotesToReserve) ? finalAvailableRemotes : null
	}
	_assignVirtualRemote(userId, doorId, permission)
	{
		return new Promise((resolve, reject) =>
		{
			(async () =>
			{
				try
				{
					let myPermission = await this._getMyPermissionInDoor(doorId)
					let virtualRemotes = this._getAvailableVirtualRemotes(myPermission, 1)
					
					if (virtualRemotes == null)
					{
						reject("No hay suficientes Mandos Virtuales en la suscripción seleccionada.")
						return
					}
					
					console.log('_assignVirtualRemote', new Date())
					let resAssign = await API.getInstance()
										  .assignVirtualRemote(virtualRemotes[0].virtualRemoteId, doorId, userId)
					
					if (resAssign.data.status)
					{
						if (permission.roleType === 'owner' &&
							permission.permissionsToGrant > 0)
						{
							let virtualRemotesToGive = this._getAvailableVirtualRemotes(myPermission, this.state.permissionsToGrant)
							if (virtualRemotesToGive == null)
							{
								reject("No hay suficientes Mandos Virtuales en la suscripción seleccionada.")
								return
							}
							
							let resGive = await this._giveVirtualRemotes(userId, doorId, virtualRemotesToGive, permission)
							resolve()
						}
						else
							resolve()
					}
					else
						reject()
				}
				catch(error)
				{
					this.permissionIdsToRevoke.push(permission.id)
					reject(error)
				}
			})()
		})
	}
	_getMyPermissionInDoor(doorId)
	{
		return new Promise((resolve, reject) =>
		{
			(async () =>
			{
				try
				{
					let myPermissionInDoor = this.state.myPermissionsInDoors.find(p => p.doorId == doorId)
					if (myPermissionInDoor != null)
					{
						console.log('Found permission locally', myPermissionInDoor)
						resolve(myPermissionInDoor)
						return
					}
					
					console.log('_getMyPermissionInDoor', new Date())
					let res = await API.getInstance().getPermissions(doorId)
					
					if (res.data.permissions == null || res.data.permissions.length === 0)
						reject()
					
					let myPermission = res.data.permissions.find(p => (p.activationDate != null && p.userId == API.getInstance().getUserId()))
					
					if (myPermission == null)
						reject()
					
					this.setState({ myPermissionsInDoors: [...this.state.myPermissionsInDoors, myPermission] }, () =>
					{
						console.log('Found permission remotely', myPermission)
						resolve(myPermission)
					})
				}
				catch (error)
				{
					reject(error)
				}
			})()
		})
	}
	_giveVirtualRemotes(userId, doorId, virtualRemotes, permission)
	{
		return new Promise((resolve, reject) =>
		{
			(async () =>
			{				
				try
				{
					console.log('_giveVirtualRemotes', new Date())
					let res = await API.getInstance().giveVirtualRemotes(virtualRemotes.map(vr => vr.virtualRemoteId), doorId, userId)
					
					resolve()
				}
				catch(error)
				{
					reject(error)
				}
			})()
		})
	}
	_reserveVirtualRemotes(permissionId, virtualRemotes)
	{
		return new Promise((resolve, reject) =>
		{
			(async () =>
			{
				try
				{
					console.log(`_reserveVirtualRemotes(${permissionId}, ${virtualRemotes.length})`, new Date())
					let res = await API.getInstance().reserveVirtualRemotes(permissionId, virtualRemotes.map(vr => vr.virtualRemoteId))
					resolve()
				}
				catch(error)
				{
					this.permissionIdsToRevoke.push(permissionId)
					reject(error)
				}
			})()
		})
	}

    _sendRemote(permissionId, email, phoneNumber)
	{
		console.log('_sendRemote', new Date())
		return new Promise((resolve, reject) =>
		{
			(async () =>
			{
				try
				{
					let response = null
					
					if (email && email.length > 0)
						response = await API.getInstance().sendInvitationEmail(permissionId, email)
					else
						response = await API.getInstance().sendInvitationSms(permissionId, phoneNumber)
					
					let updatedStatusResponses = this.state.permissionStatusResponses.map(psr =>
					{
						if (psr.id === permissionId)
							return { ...psr, invitationEmailSentOk: response.data.emailSent || response.data.smsSent }
						else
							return psr
					})
					this.setState({ permissionStatusResponses: updatedStatusResponses }, () => resolve())
				}
				catch(error)
				{
					console.log(error)
					let updatedStatusResponses = this.state.permissionStatusResponses.map(psr =>
					{
						if (psr.id === permissionId)
							return { ...psr, invitationEmailSentOk: false }
						else
							return psr
					})
					this.setState({ permissionStatusResponses: updatedStatusResponses }, () => reject(error))
				}
			})()
		})
    }

    onEditPermissions()
    {
        this.props.onEditPermissions(this.props.selectedDoors)
    }
}
